import React from 'react'
import styles from '@styles/components/Modal.module.css'
import designSystem from '@styles/designSystem'
import { ReactComponent as CloseSVG } from '@assets/SVGs/QontactPoint/xSVG.svg';

interface ModalProps {
    children: React.ReactNode
    isOpen: boolean
    onClose: () => void
    width?: string
    height?: string
    maxWidth?: string
    maxHeight?: string
}

export const Modal: React.FC<ModalProps> = ({
    children,
    isOpen,
    onClose,
    width = '80%',
    height = 'auto',
    maxWidth = '1200px',
    maxHeight = '90vh'
}) => {
    if (!isOpen) return null

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose()
        }
    }

    return (
        <div className={styles['modal-backdrop']} onClick={handleBackdropClick}>
            <div 
                className={styles['modal-container']}
                style={{
                    width: width,
                    height: height,
                    maxWidth: maxWidth,
                    maxHeight: maxHeight
                }}
            >
                <button 
                    className={styles['close-button']}
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    <CloseSVG />
                </button>
                <div className={styles['modal-content']}>
                    {children}
                </div>
            </div>
        </div>
    )
}